import { ReactElement } from 'react'
import { ListItemText, PrimaryAccount, SecondaryAccount } from './subcomponents'
import { SwitchAccountListItemProps } from './typing'

const SwitchAccountListItem = ({
  isPrimary,
  accountName,
  accountNumber,
  setActiveAccount,
  activeAccount,
  maskedAccountNumber,
  relationship,
  secondaryRelationship
}: SwitchAccountListItemProps): ReactElement => {
  const initialsOfAccountName: string[] = accountName.split(' ')
  const accountNameNumber = isPrimary
    ? `PRIMARY - ${initialsOfAccountName[0]} (....${maskedAccountNumber})`
    : `${initialsOfAccountName[0]} (....${maskedAccountNumber})`

  return isPrimary || accountNumber === activeAccount ? (
    <PrimaryAccount
      key={maskedAccountNumber}
      onClick={(): void => setActiveAccount(accountNumber)}
      isParent={relationship === 'PARENT' && isPrimary}
      isSecondary={secondaryRelationship === 'PARENT'}
      relationship={isPrimary}
      buttonType="text"
    >
      <ListItemText isPrimary isSecondary={relationship === 'PARENT'}>
        {accountNameNumber}
      </ListItemText>{' '}
    </PrimaryAccount>
  ) : (
    <SecondaryAccount
      key={maskedAccountNumber}
      onClick={(): void => setActiveAccount(accountNumber)}
      buttonType="text"
    >
      <ListItemText>{accountNameNumber}</ListItemText>
    </SecondaryAccount>
  )
}

export default SwitchAccountListItem
